import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const UbahDataPermohonan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const { id } = useParams();
  const navigate = useNavigate();

  const [namaPemohon, setNamaPemohon] = useState("");
  const [selectedNamaPemohon, setSelectedNamaPemohon] = useState(null);
  const [namaPemohons, setNamaPemohons] = useState([]);
  const [openPermohonan, setOpenPermohonan] = useState(false);
  let [pagePermohonan, setPagePermohonan] = useState(0);
  const [limitPermohonan] = useState(10);
  const [pagesPermohonan, setPagesPermohonan] = useState(0);
  const [queryPermohonan, setQueryPermohonan] = useState("");
  const [searchTermPermohonan, setSearchTermPermohonan] = useState("");
  const [statusDokumen, setStatusDokumen] = useState("SUDAH LENGKAP");
  const [keteranganSusulan, setKeteranganSusulan] = useState("");
  const [noJual, setNoJual] = useState("");
  const [nopol, setNopol] = useState("");
  const [alamat, setAlamat] = useState("");
  const [statusRo, setStatusRo] = useState("BARU");
  const [butuhVerifikasi, setButuhVerifikasi] = useState("TIDAK");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getDataPermohonan();
  }, [id]);

  useEffect(() => {
    getPermohonans();
  }, [pagePermohonan, searchTermPermohonan]);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const getDataPermohonan = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/dataPermohonans/${id}`, {
        id: user._id,
        token: user.token,
      });
      setNamaPemohon(response.data.namaPemohon?._id || "");
      setSelectedNamaPemohon(response.data.namaPemohon || null);
      setStatusDokumen(response.data.statusDokumen || "SUDAH LENGKAP");
      setKeteranganSusulan(response.data.keteranganSusulan || "");
      setNoJual(response.data.noJual || "");
      setNopol(response.data.nopol || "");
      setAlamat(response.data.alamat || "");
      setStatusRo(response.data.statusRo || "BARU");
      setButuhVerifikasi(response.data.butuhVerifikasi || "TIDAK");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data permohonan.");
    }
    setLoading(false);
  };

  const getPermohonans = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/namaPemohonsPagination?available_admin=true&search_query=${encodeURIComponent(searchTermPermohonan)}&page=${pagePermohonan}&limit=${limitPermohonan}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQueryPermohonan(searchTermPermohonan);
      setNamaPemohons(response.data.namaPemohons);
      setPagePermohonan(response.data.page);
      setPagesPermohonan(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data permohonan.");
    }
    setLoading(false);
  };

  const permohonanHandler = (value) => {
    const pickedNamaPemohon = namaPemohons.find((item) => item._id === value);
    setNamaPemohon(value);
    setSelectedNamaPemohon(pickedNamaPemohon || null);
    setOpenPermohonan(false);
  };

  const statusDokumenHandler = (value) => {
    setStatusDokumen(value);
    if (value !== "PERLU DATA SUSULAN") {
      setKeteranganSusulan("");
    }
  };

  const handleChangePermohonan = (e, p) => {
    setPagePermohonan(p - 1);
  };

  const searchDataPermohonan = (event) => {
    event.preventDefault();
    setPagePermohonan(0);
    setSearchTermPermohonan(queryPermohonan);
  };

  const updateDataPermohonan = async (event) => {
    event.preventDefault();

    if (!namaPemohon || !statusDokumen || !noJual || !nopol || !alamat || !statusRo || !butuhVerifikasi) {
      setError("Nama Pemohon, status dokumen, no jual, nopol, alamat, status RO, dan butuh verifikasi wajib diisi.");
      return;
    }

    if (statusDokumen === "PERLU DATA SUSULAN" && !keteranganSusulan) {
      setError("Keterangan susulan wajib diisi jika status dokumen perlu data susulan.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${tempUrl}/updateDataPermohonan/${id}`, {
        namaPemohon,
        statusDokumen,
        keteranganSusulan,
        noJual,
        nopol,
        alamat,
        statusRo,
        butuhVerifikasi,
        id: user._id,
        token: user.token,
      });
      navigate(`/dataPermohonan/${id}`);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengubah data permohonan.");
    }
    setLoading(false);
  };

  const renderDialogPermohonan = () => {
    return (
      <Dialog open={openPermohonan} onClose={() => setOpenPermohonan(false)} maxWidth="md" fullWidth>
        <DialogTitle>{`Pilih Nama Pemohon`}</DialogTitle>
        <DialogContent>
          <Form onSubmit={searchDataPermohonan}>
            <div className="search-row mt-0 mb-3">
              <Form.Control
                value={queryPermohonan}
                placeholder="Cari nama pemohon atau alasan setuju..."
                onChange={(e) => setQueryPermohonan(e.target.value)}
              />
              <Button type="submit">Cari</Button>
            </div>
          </Form>
          <TableContainer component={Paper}>
            <Table aria-label="pilih permohonan">
              <TableHead>
                <TableRow>
                  <TableCell>Nama Pemohon</TableCell>
                  <TableCell>Alasan</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {namaPemohons.map((item) => (
                  <TableRow
                    key={item._id}
                    className="row-clickable"
                    onClick={() => permohonanHandler(item._id)}
                  >
                    <TableCell>{item.permohonan?.namaPemohon || "-"}</TableCell>
                    <TableCell>{item.alasanSetuju || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search-row">
            <Pagination
              count={pagesPermohonan}
              page={pagePermohonan + 1}
              onChange={handleChangePermohonan}
              color="primary"
              size={screenSize <= 600 ? "small" : "medium"}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-back" variant="outline-secondary" type="button" onClick={() => setOpenPermohonan(false)}>
            {"< Kembali"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Ubah Data Permohonan</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={updateDataPermohonan}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nama Pemohon</Form.Label>
                <Form.Control
                  value={selectedNamaPemohon?.permohonan?.namaPemohon || ""}
                  placeholder="PILIH NAMA PEMOHON"
                  readOnly
                  onClick={() => setOpenPermohonan(true)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Alasan</Form.Label>
                <Form.Control value={selectedNamaPemohon?.alasanSetuju || ""} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status Dokumen</Form.Label>
                <Form.Select value={statusDokumen} onChange={(e) => statusDokumenHandler(e.target.value)}>
                  <option value="SUDAH LENGKAP">SUDAH LENGKAP</option>
                  <option value="PERLU DATA SUSULAN">PERLU DATA SUSULAN</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Keterangan Susulan</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={keteranganSusulan}
                  disabled={statusDokumen !== "PERLU DATA SUSULAN"}
                  onChange={(e) => setKeteranganSusulan(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>No Jual</Form.Label>
                <Form.Control value={noJual} onChange={(e) => setNoJual(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nopol</Form.Label>
                <Form.Control value={nopol} onChange={(e) => setNopol(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Alamat</Form.Label>
                <Form.Control as="textarea" rows={3} value={alamat} onChange={(e) => setAlamat(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status RO</Form.Label>
                <Form.Select value={statusRo} onChange={(e) => setStatusRo(e.target.value)}>
                  <option value="RO">RO</option>
                  <option value="BARU">BARU</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Butuh Verifikasi</Form.Label>
                <Form.Select value={butuhVerifikasi} onChange={(e) => setButuhVerifikasi(e.target.value)}>
                  <option value="YA">YA</option>
                  <option value="TIDAK">TIDAK</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate(`/dataPermohonan/${id}`)}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
      {renderDialogPermohonan()}
    </div>
  );
};

export default UbahDataPermohonan;

